import type { ClientInput, FrequencyPrescription } from '../types';
import type { Tracer } from '../tracer';

/**
 * Frequency rule — number of muscle groups touched per session, derived
 * from training days per week. Aligns with split selection downstream.
 */
export function frequencyRule(client: ClientInput, trace: Tracer): FrequencyPrescription {
  const days = client.schedule.days_per_week;
  const muscleGroupsPerSession = muscleGroupsForDays(days);

  trace.emit(
    'frequency',
    `${muscleGroupsPerSession} muscle groups per session`,
    `Days/week: ${days}`,
    { days_per_week: days },
  );

  return { muscle_groups_per_session: muscleGroupsPerSession };
}

function muscleGroupsForDays(days: number): number {
  // Fewer days/week → more muscle groups per session (full body).
  // More days/week → fewer per session (specialized split).
  if (days <= 2) return 6;
  if (days === 3) return 5;
  if (days === 4) return 4;
  if (days === 5) return 3;
  return 2; // 6 days/week → PPL × 2, very specialized
}

export const _internal = { muscleGroupsForDays };
